var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showReturnToTop),expression:"showReturnToTop"}],staticClass:"back-to-top",on:{"click":_vm.backToTop}},[_c('span',{staticClass:"tips",class:[_vm.bttOption.iPos],style:({color:_vm.bttOption.textColor})},[_c('img',{attrs:{"src":_vm.img,"width":"30","height":"30"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba48895a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BackTop.vue
// module id = null
// module chunks = 